import {
  AngularComponentsModule,
  GoabTable,
  GoabText,
} from '@abgov/angular-components';
import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FacilityEntryBedRowStateService } from '../../../../services-v2/states/facility-entry-bed-row.state.service';
import { FacilityBedsEntryRow } from '../facility-beds-entry-row/facility-beds-entry-row';

@Component({
  selector: 'app-facility-beds-grid',
  imports: [
    CommonModule,
    AngularComponentsModule,
    FacilityBedsEntryRow,
    GoabTable,
    GoabText,
    ReactiveFormsModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './facility-beds-grid.html',
  styleUrl: './facility-beds-grid.scss',
})
export class FacilityBedsGrid {
  private readonly _facilityEntryBedRowStateService = inject(
    FacilityEntryBedRowStateService
  );

  facilityBeds = this._facilityEntryBedRowStateService.selectFacilityBedsRows;

  resolveHasEmptyReasonsFlagForRow(bedType: string): boolean {
    const facilityBeds = this.facilityBeds;
    const [currentRow] = facilityBeds().filter((r) => r.bedType === bedType);
    return currentRow ? currentRow.hasEmptyBeds === true : false;
  }
}
